module.exports = __webpack_public_path__ + "img/consFour.2bd69bd6.svg";